import { computed } from 'vue';
import store from '@/store';

export default class SuccessMessageCode {

	public successMessage = computed((): string => {
		return store.getters.successMessage();
	});
}
